var React = require('react');

function PaginationLeftArrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 120V0C33.1371 0 60 26.8629 60 60C60 93.1371 33.1371 120 0 120ZM25.4142 70.5858C26.1953 71.3668 26.1953 72.6332 25.4142 73.4142C24.6332 74.1953 23.3668 74.1953 22.5858 73.4142L10.5858 61.4142C10.2107 61.0391 10 60.5304 10 60C10 59.4696 10.2107 58.9609 10.5858 58.5858L22.5858 46.5858C23.3668 45.8047 24.6332 45.8047 25.4142 46.5858C26.1953 47.3668 26.1953 48.6332 25.4142 49.4142L16.5784 58.25H40C41.1046 58.25 42 59.1454 42 60.25C42 61.3546 41.1046 62.25 40 62.25H17.0784L25.4142 70.5858Z","fill":"white","fillOpacity":"0.5"}));
}

PaginationLeftArrow.defaultProps = {"width":"60","height":"120","viewBox":"0 0 60 120","fill":"none"};

module.exports = PaginationLeftArrow;

PaginationLeftArrow.default = PaginationLeftArrow;
